import { render, staticRenderFns } from "./AdminRoles.vue?vue&type=template&id=2d095922&scoped=true"
import script from "./AdminRoles.vue?vue&type=script&lang=js"
export * from "./AdminRoles.vue?vue&type=script&lang=js"
import style0 from "./AdminRoles.vue?vue&type=style&index=0&id=2d095922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d095922",
  null
  
)

export default component.exports